'use strict'

import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

const getCustomLanguages = () => {
    return [
        {l: 'JA', i: 'jp', r: 0, t: 'JA'},
        {l: 'KO', i: 'kr', r: 0, t: 'KO'},
        {l: 'UK', i: 'uk', r: 0, t: 'UK'},
        {l: 'TR', i: 'tr', r: 0, t: 'TR'},
        {l: 'ZH-HANT', i: 'zh', r: 0, t: 'ZH'}
    ]
}

export const getConsentManagerUrl = (consentManagerScriptId) => {
    return `https://cdn.consentmanager.net/delivery/autoblocking/${consentManagerScriptId}.js`
}

export const getConsentManagerConfig = () => {
    const {cmp} = getConfig()
    const customLanguages = getCustomLanguages()
    return {
        enabled: cmp.enabled,
        scriptId: cmp.scriptId,
        customLanguages: customLanguages,
        url: getConsentManagerUrl(cmp.scriptId)
    }
}
